export default function EstimateIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.43537 7.74773C2.75799 7.49725 3.34012 7.12101 3.91461 6.85717C5.10139 6.31211 6.7096 6.12009 8.55308 7.39743C9.85911 8.30237 10.93 8.14706 11.7202 7.79053C12.3748 7.49516 13.4839 6.46657 13.7865 6.14258L13.789 8.86975C13.4628 9.12852 12.9321 9.49727 12.348 9.7608C11.1499 10.3014 9.5078 10.4973 7.66203 9.21839C6.35371 8.31186 5.31879 8.47093 4.55221 8.823C3.87339 9.13476 2.98393 9.64792 2.42896 10.2861L2.43537 7.74773Z"
        fill="#8C8C8C"
      />
    </svg>
  );
}
